import React from 'react';
import { useContext, useState, useEffect } from 'react';
import { Box, Button, Modal } from '@mui/material';
import { OrdersContext } from '../lib/contexts/OrdersContext';
import { BenefitDetailsContext } from '../lib/contexts/BenefitDetailsContext';
import ProgramInfoCard from './OrderManagementScreen/components/ProgramInfoCard';
import DeliveryDetails from './OrderManagementScreen/components/DeliveryDetails';
import { Divider } from '@mui/material';
import MealInfoCard from './OrderManagementScreen/components/MealInfoCard';
import CurrentChallengeCard from './OrderManagementScreen/components/CurrentChallengeCard';
import usePatientData from '../lib/hooks/usePatientData';
import CurrentChallengeStreakCard from './OrderManagementScreen/components/CurrentChallengeStreakCard';
import MiniDeliveryDetails from './OrderManagementScreen/components/MiniDeliveryDetails';
import OrderDetails from './OrderManagementScreen/components/OrderDetails';
import ReportOrderIssueCard from './OrderManagementScreen/components/subComponents/ReportOrderIssueCard';
import OrderListPopUp from './OrderManagementScreen/components/OrderListPopUp';
import Footer from './OrderManagementScreen/components/Footer';
import { PartnerContext } from '../lib/contexts/PartnerContext';
import { getCustomQuestions } from '../lib/api/getCustomQuestions';
import MiniInfoBlock from './OrderManagementScreen/components/subComponents/MiniInfoBlock';
import NewProgramInfoCard from './OrderManagementScreen/components/NewProgramInfoCard';
import DietQualityGoalCard from './OrderManagementScreen/components/DietQualityGoalCard';
import Banner from '../components/Banner';
import InfoUpdateCard from './OrderManagementScreen/components/InfoUpdateCard';
const SecretTestPage = () => {
  const { state } = useContext(OrdersContext);
  const { benefitDetails, setBenefitDetails } = useContext(BenefitDetailsContext);
  const [testMeal, setTestMeal] = useState(null);
  const { state: partnerState } = useContext(PartnerContext);
  useEffect(() => {
    if (
      state.ordersData &&
      state.ordersData.length > 0 &&
      state.ordersData[0].order_items &&
      state.ordersData[0].order_items.length > 0
    ) {
      setTestMeal(state.ordersData[0].order_items[0]);
    }
  }, [state]);
  const [programInfo, setProgramInfo] = useState({
    name: 'No Program',
    weeksLeft: 0,
    isActive: false,
    mealsPerWeek: 0,
    totalWeeks: 0,
    startDate: '',
    endDate: '',
    reEnrollTime: '',
  });

  const logoData = partnerState
    ? {
        large: partnerState.logo_large_url,
        lightLarge: partnerState.logo_light_large_url,
        lightMedium: partnerState.logo_light_medium_url,
        lightSmall: partnerState.logo_light_small_url,
        medium: partnerState.logo_medium_url,
        small: partnerState.logo_small_url,
      }
    : {};

  const [order, setOrder] = useState(null);
  const [mealsData, setMealsData] = useState(null);
  const [challengeData, setChallengeData] = useState({
    challenge: 'Avoid Fast Food For 1 Week',
    weekStreak: 3,
    thisWeekCheckIn: {
      monday: 'checked',
      tuesday: 'not checked',
      wednesday: 'checked',
      thursday: 'checked',
      friday: 'checked',
      saturday: 'tbd',
      sunday: 'tbd',
    },
  });
  const [isReportIssueOpen, setIsReportIssueOpen] = useState(false);
  const [providerView, setProviderView] = useState(false);

  const [testProgramInfo, setTestProgramInfo] = useState({
    auth_end_date: '2025-01-25',
    auth_start_date: '2024-01-25',
    benefit_id: 48,
    // benefit_name: 'CalOptima Master Benefit',
    benefit_name: '',
    meal_grocery_auth_no: '123456789',
    no_of_meals: 12,
    provider_name: 'CalOptima',
    rd_authorization_no: '123456789',
    status: 'No application data',
  });

  const [dietQualityScore, setDietQualityScore] = useState(10);
  const [goalDietQualityScore, setGoalDietQualityScore] = useState(10);

  const [isBannerOpen, setIsBannerOpen] = useState(false);

  useEffect(() => {
    if (benefitDetails) {
      setProgramInfo(benefitDetails);
    }
  }, [benefitDetails]);

  useEffect(() => {
    if (state.ordersData && state.ordersData.programInfo) {
      setProgramInfo(state.ordersData.programInfo);
    }
    if (state.ordersData && state.ordersData.thisWeekOrders) {
      setOrder(state.ordersData.thisWeekOrders[0]);
    }
  }, [state.ordersData]);

  useEffect(() => {
    if (state.mealOptionsData) {
      setMealsData(state.mealOptionsData);
    }
  }, [state]);

  // useEffect(() => {
  //   if(mealsData) {
  //     console.log('mealsData in SecretTestPage: ', mealsData);
  //     console.log('order in SecretTestPage: ', state.ordersData[0].order_items[0]);
  //   }
  // }, [mealsData])

  const handleOrderStatusChange = (event) => {
    const newStatus = event.target.value;
    setOrder((prevOrder) => ({
      ...prevOrder,
      status: newStatus,
    }));
  };

  const handleOrderChange = (event) => {
    const newOrderId = event.target.value;
    const allOrders = [
      ...state.ordersData.thisWeekOrders,
      ...state.ordersData.nextWeekOrders,
      ...state.ordersData.futureOrders,
      ...state.ordersData.distantFutureOrders,
      ...state.ordersData.historyOrders,
    ];

    const newOrder = allOrders.find((order) => order.id === parseInt(newOrderId, 10));

    if (newOrder) {
      setOrder(newOrder);
    }
  };

  const handleApplicationStatusChange = (event) => {
    const newStatus = event.target.value;
    setProgramInfo((prevInfo) => ({
      ...prevInfo,
      applicationStatus: {
        ...prevInfo.applicationStatus,
        status: newStatus,
      },
    }));
  };

  const handleMessageChange = (event) => {
    setProgramInfo((prevInfo) => ({
      ...prevInfo,
      applicationStatus: {
        ...prevInfo.applicationStatus,
        message: event.target.value,
      },
    }));
  };

  const handleProgressNoteChange = (event) => {
    setProgramInfo((prevInfo) => ({
      ...prevInfo,
      applicationStatus: {
        ...prevInfo.applicationStatus,
        progressNote: event.target.value,
      },
    }));
  };
  const handleCheckInChange = (day, event) => {
    const newStatus = event.target.value;
    setChallengeData((prevData) => ({
      ...prevData,
      thisWeekCheckIn: {
        ...prevData.thisWeekCheckIn,
        [day]: newStatus,
      },
    }));
  };

  const incrementStreak = () => {
    setChallengeData((prevData) => ({
      ...prevData,
      weekStreak: prevData.weekStreak + 1,
    }));
  };

  const decrementStreak = () => {
    setChallengeData((prevData) => ({
      ...prevData,
      weekStreak: Math.max(prevData.weekStreak - 1, 0),
    }));
  };

  const handleChallengeChange = (event) => {
    const newChallenge = event.target.value;
    setChallengeData((prevData) => ({
      ...prevData,
      challenge: newChallenge,
    }));
  };

  const toggleReportIssueCard = () => {
    setIsReportIssueOpen((prev) => !prev);
  };

  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    setBenefitDetails((prevDetails) => ({
      ...prevDetails,
      status: newStatus,
    }));
  };

  const handleTestProgramStatusChange = (event) => {
    const newStatus = event.target.value;
    setTestProgramInfo((prevInfo) => ({
      ...prevInfo,
      status: newStatus,
    }));
  };

  useEffect(() => {
    setBenefitDetails(testProgramInfo);
  }, []);

  // const statusMapList = {
  //   Canceled: 'Canceled',
  //   'Active:NO_AUTH_END': 'Active',
  //   Approved: 'Approved',
  //   Active: 'Active',
  //   Accepted: 'Accepted',
  //   Completed: 'Completed',
  //   Submitted: 'Pending',
  //   Eligible: 'Eligible',
  //   Ineligible: 'Not Eligible',
  //   'In Process': 'Pending',
  //   'In Review': 'Pending',
  //   'Incomplete application': 'Incomplete',
  //   'No Application Data': 'Not Started',
  //   'Active - Re-Auth Available': 'Active - Time to Renew',
  //   Waitlist: 'Waitlisted',
  // };

  const statusMapList = {
    'Lead Created': 'Lead Created', // 'Not Started' or 'In Progress', depending on the progress of the users assessment
    'Eligible Lead': 'In Review',
    'Ready for Re-Auth': 'ReAuth', // triggers a push notification to user depending on expiration date
    'Re-Auth Eligible': 'In Review',
    'Re-Auth Verified': 'In Review',
    'Payer Verified': 'In Review',
    'RD Needed': 'In Review',
    'MNT Session Needed': 'Action Required',
    'MNT Scheduled': 'In Review',
    'Ready to Submit': 'In Review',
    'Submitted to Payer': 'Awaiting Approval',
    Activated: 'Active',
    Canceled: 'Canceled',
    Completed: 'Completed',
    Ineligible: 'Not Eligible',
    Waitlisted: 'Waitlisted',
  };

  // console.log('here are the benefitDetails in SecretTestPage: ', benefitDetails);

  const toggleBanner = () => {
    setIsBannerOpen((prev) => !prev);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        overflowX: 'hidden',
        boxSizing: 'border-box',
      }}
    >
      {isBannerOpen && <Banner />}

      <Divider sx={{ width: '100%', margin: '20px 0' }} />

      <div>Here are programInfoCard Versions</div>
      {/* {programInfo ? (
          <div>
            <div>
              <label htmlFor="progress-note-select">Progress Note: </label>
              <select id="progress-note-select" value={programInfo.applicationStatus.progressNote} onChange={handleProgressNoteChange}>
                <option value="">None</option>
                <option value="0/3 Sessions Booked">0/3 Sessions Booked</option>
                <option value="Action Required">Action Required</option>
              </select>
            </div>
            <div>
              <label htmlFor="status-select">Application Status: </label>
              <select id="status-select" value={programInfo.applicationStatus.status} onChange={handleApplicationStatusChange}>
                <option value="Active">Active</option>
                <option value="Pending">Pending</option>
                <option value="Not Eligible">Not Eligible</option>
                <option value="Action Required">Action Required</option>
              </select>
            </div>
            <div>
              <label htmlFor="message-select">Application Message: </label>
              <select id="message-select" value={programInfo.applicationStatus.message} onChange={handleMessageChange}>
                <option value="Book time with a registered dietitian to review your Nutrition Check-Up">
                  Book time with a registered dietitian to review your Nutrition Check-Up
                </option>
                <option value="We're working on confirming your eligibility for our Medically-Tailored Food Program with your health plan">
                  We're working on confirming your eligibility for our Medically-Tailored Food Program with your health plan
                </option>
                <option value="Once complete, our team can check your eligibility for our Medically-Tailored Food Program with your health plan.">
                  Once complete, our team can check your eligibility for our Medically-Tailored Food Program with your health plan.
                </option>
                <option value="Looks like you didn't qualify for our Medically-Tailored Food Program with CenCal">
                  Looks like you didn't qualify for our Medically-Tailored Food Program with CenCal
                </option>
              </select>
            </div>
            <div>
              <label htmlFor="action-required-select">Action Required: </label>
              <select
                id="action-required-select"
                value={programInfo.applicationStatus.actionRequired}
                onChange={(event) => {
                  setProgramInfo((prevInfo) => ({
                    ...prevInfo,
                    applicationStatus: {
                      ...prevInfo.applicationStatus,
                      actionRequired: event.target.value,
                    },
                  }));
                }}
              >
                <option value="Meet with Your Tangelo Dietitian">Meet with Your Tangelo Dietitian</option>
                <option value="Finish Applicaiton">Finish Applicaiton</option>
                <option value="Application Not Approved">Application Not Approved</option>
              </select>
            </div>
            <div>Meals Per Week: {programInfo.mealsPerWeek}</div>
            <div>Total Weeks: {programInfo.totalWeeks}</div>
            <div>Start Date: {programInfo.startDate}</div>
            <div>End Date: {programInfo.endDate}</div>
            <div>Re-Enroll Time: {programInfo.reEnrollTime}</div>
          </div>
        ) : (
          'Loading...'
        )} */}
      <div>Here is the ProgramInfoCard:</div>

      {benefitDetails && (
        <div>
          <label htmlFor="status-select">Benefit Status: </label>
          <select
            id="status-select"
            value={benefitDetails.status}
            onChange={handleStatusChange}
          >
            {Object.keys(statusMapList).map((status) => (
              <option
                key={status}
                value={status}
              >
                {status}
              </option>
              // <option value="Eligible">Eligible</option>
              // <option value="In Process">Pending</option>
              // <option value="Action Required">Action Required</option>
              // <option value="Ineligible">Not Eligible</option>
              // <option value="Incomplete application">Incomplete application</option>
            ))}
          </select>
        </div>
      )}
      <div>
        <label htmlFor="provider-view-select">Provider View: </label>
        <select
          id="provider-view-select"
          value={providerView ? 'On' : 'Off'}
          onChange={(event) => setProviderView(event.target.value === 'On')}
        >
          <option value="On">On</option>
          <option value="Off">Off</option>
        </select>
      </div>
      <Box sx={{ maxWidth: '650px' }}>
        {programInfo && (
          <ProgramInfoCard
            programInfo={benefitDetails}
            providerView={providerView}
          />
        )}
      </Box>
      <Divider sx={{ width: '100%', margin: '20px 0' }} />
      <div>Here is the NewProgramInfoCard</div>

      <div>
        <label htmlFor="test-program-status-select">Test Program Status: </label>
        <select
          id="test-program-status-select"
          value={testProgramInfo.status}
          onChange={handleTestProgramStatusChange}
        >
          {Object.keys(statusMapList).map((status) => (
            <option
              key={status}
              value={status}
            >
              {status}
            </option>
          ))}
        </select>
      </div>

      <NewProgramInfoCard
        programInfo={testProgramInfo}
        providerView={providerView}
      />
      <Divider sx={{ width: '100%', margin: '20px 0' }} />
      <div>here is dietqualitygoalcard</div>
      <div>
        <label htmlFor="diet-quality-score-select">Diet Quality Score: </label>
        <select
          id="diet-quality-score-select"
          value={dietQualityScore}
          onChange={(event) => setDietQualityScore(parseInt(event.target.value, 10))}
        >
          {[...Array(10).keys()].map((score) => (
            <option
              key={score + 1}
              value={score + 1}
            >
              {score + 1}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor="goal-diet-quality-score-select">Goal Diet Quality Score: </label>
        <select
          id="goal-diet-quality-score-select"
          value={goalDietQualityScore}
          onChange={(event) => setGoalDietQualityScore(parseInt(event.target.value, 10))}
        >
          {[...Array(10).keys()].map((score) => (
            <option
              key={score + 1}
              value={score + 1}
            >
              {score + 1}
            </option>
          ))}
        </select>
      </div>
      <DietQualityGoalCard
        dietQualityScore={dietQualityScore}
        goalDietQualityScore={goalDietQualityScore}
      />
      <Divider sx={{ width: '100%', margin: '20px 0' }} />
      <div>Here is the DeliveryDetailsCard</div>
      {order ? (
        <div>
          <div>
            <label htmlFor="order-select">Order: </label>
            <select
              id="order-select"
              value={order.id}
              onChange={handleOrderChange}
            >
              <option value={1}>Order 1</option>
              <option value={2}>Order 2</option>
              <option value={3}>Order 3</option>
              <option value={4}>Order 4</option>
              <option value={5}>Order 5</option>
              <option value={6}>Order 6</option>
              <option value={7}>Order 7</option>
              <option value={8}>Order 8</option>
              <option value={9}>Order 9</option>
            </select>
          </div>
          {/* <div>
              <label htmlFor="status-select">Status: </label>
              <select
                id="status-select"
                value={order.status}
                onChange={handleOrderStatusChange}
              >
                <option value="Order Placed">Order Placed</option>
                <option value="Shipped">Shipped</option>
                <option value="Out for Delivery">Out for Delivery</option>
                <option value="Delivered">Delivered</option>
              </select>
            </div> */}
          <div>Status: {order.status}</div>
          <div>Meal Genre: {order.mealGenre}</div>
          <div>Delivery Date: {order.deliveryDate}</div>
          <div>Address: {order.address}</div>
          <div>Order Placed: {order.orderPlaced}</div>
          <div>Shipped: {order.shipped}</div>
          <div>Meals:</div>
          <ul>
            {order.meals.map((meal) => (
              <li key={meal.id}>
                {meal.name} - Quantity: {meal.quantity}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        'Loading...'
      )}
      {order && <DeliveryDetails delivery={order} />}
      <Divider sx={{ width: '100%', margin: '20px 0' }} />
      <div>Here is the MealInfoCard (with manual test data only)</div>
      {/* <MealInfoCard mealInfo={state?.ordersData?.mealInfo['001']} order={order} meal={order?.meals[0]} /> */}
      {/* {testMeal && <MealInfoCard mealInfo={testMeal} meal={testMeal} />} */}
      <Divider sx={{ width: '100%', margin: '20px 0' }} />
      <div>Here is the InfoUpdateCard</div>
      <div>Here is the InfoUpdateCard for Phone Number</div>
      <InfoUpdateCard editedInfo="phone" />
      <div>Here is the InfoUpdateCard for Email</div>
      <InfoUpdateCard editedInfo="email" />
      <Divider sx={{ width: '100%', margin: '20px 0' }} />
      <div>Here is the MiniInfoBlock</div>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <MiniInfoBlock
          title="Phone Number"
          value="123-456-7890"
        />
      </Box>
      <Divider sx={{ width: '100%', margin: '20px 0' }} />
      {order ? (
        <div>
          <div>Meals:</div>
          <ul>
            {order.meals.map((meal) => (
              <li key={meal.id}>
                {meal.name} - Quantity: {meal.quantity}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div>Loading...</div>
      )}
      {/* <MealInfoCard mealInfo={state?.ordersData?.mealInfo['001']} order={order} meal={order?.meals[0]} /> */}
      <Divider sx={{ width: '100%', margin: '20px 0' }} />
      <div>Here is the CurrentChallengeCard</div>

      <div>
        <div>
          <label>Week Streak: {challengeData.weekStreak}</label>
          <button onClick={decrementStreak}>-</button>
          <button onClick={incrementStreak}>+</button>
        </div>
        <div>
          <label htmlFor="challenge-input">Challenge: </label>
          <input
            id="challenge-input"
            type="text"
            value={challengeData.challenge}
            onChange={handleChallengeChange}
          />
        </div>
        {Object.keys(challengeData.thisWeekCheckIn).map((day) => (
          <div key={day}>
            <label htmlFor={`${day}-select`}>{day.charAt(0).toUpperCase() + day.slice(1)}: </label>
            <select
              id={`${day}-select`}
              value={challengeData.thisWeekCheckIn[day]}
              onChange={(event) => handleCheckInChange(day, event)}
            >
              <option value="checked">Checked</option>
              <option value="not checked">Not Checked</option>
              <option value="tbd">TBD</option>
            </select>
          </div>
        ))}
      </div>
      <CurrentChallengeCard challengeData={challengeData} />
      <Divider sx={{ width: '100%', margin: '20px 0' }} />
      <div>Here is the CurrentChallengeStreakCard</div>
      <CurrentChallengeStreakCard challengeData={challengeData} />
      <Divider sx={{ width: '100%', margin: '20px 0' }} />
      <div>Here is the MiniDeliveryDetails</div>
      {order && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <MiniDeliveryDetails order={order} />
        </Box>
      )}
      <div>Here is the OrderDetails</div>
      {order && (
        <OrderDetails
          key={order.id}
          order={order}
        />
      )}
      <Divider sx={{ width: '100%', margin: '20px 0' }} />
      <div>Here is the ReportOrderIssueCard</div>
      <Button onClick={toggleReportIssueCard}>Open ReportOrderIssueCard</Button>
      <Modal
        open={isReportIssueOpen}
        onClose={toggleReportIssueCard}
        aria-labelledby="report-order-issue-modal"
        aria-describedby="report-order-issue-description"
      >
        <ReportOrderIssueCard onClose={toggleReportIssueCard} />
      </Modal>
      <Divider sx={{ width: '100%', margin: '20px 0' }} />
      <div>Here is the OrderListPopUp</div>
      {/* <OrderListPopUp /> */}
      <Divider sx={{ width: '100%', margin: '20px 0' }} />

      <div style={{ textAlign: 'center' }}>
        <h3>Partner Logos</h3>
        {partnerState &&
          Object.entries(logoData).map(([key, url]) => (
            <div
              key={key}
              style={{ marginBottom: '10px' }}
            >
              <div>{key.charAt(0).toUpperCase() + key.slice(1)}:</div>
              <img
                src={url}
                alt={`${key} logo`}
                style={{ maxWidth: '100px', maxHeight: '100px' }}
              />
            </div>
          ))}
      </div>

      <Divider sx={{ width: '100%', margin: '20px 0' }} />

      <div>Here is the Custom Questions console log</div>
      <Button onClick={() => console.log(getCustomQuestions())}>Get Custom Questions</Button>

      <Divider sx={{ width: '100%', margin: '20px 0' }} />

      <Button onClick={toggleBanner}>Toggle Banner</Button>

      <Divider sx={{ width: '100%', margin: '20px 0' }} />

      {/* <Footer /> */}
    </div>
  );
};

export default SecretTestPage;
